/**
 * GENERATED by apps/api/scripts/refresh-rh-stocks.ts on 2026-10-24 at Robinhood Chain block 97129091. Do not edit.
 *
 * Every Robinhood Stock Token (StockFactory 0x4783C67b63dE2B358Ac5951a7D41F47A38F3C046) with a Uniswap pool against ETH or
 * USDG whose liquidity is confirmed on-chain and is at least $10,000 (DexScreener estimate).
 * 204 Stock Tokens deployed, 77 tradable by this rule. Liquidity figures are a snapshot.
 */
export type RhStockToken = {
  symbol: string;
  name: string;
  address: `0x${string}`;
  decimals: number;
  liquidityUsd: number | null;
  volume24hUsd: number | null;
  bestPool: { version: "v2" | "v3" | "v4"; id: string; quote: string; fee: number | null; liquidityUsd: number | null };
  pools: number;
};

export const RH_STOCKS_SNAPSHOT = { date: "2026-10-24", block: 97129091, deployed: 204, minLiquidityUsd: 10000 } as const;

export const RH_STOCKS: RhStockToken[] = [
  {
    "symbol": "SPY",
    "name": "SPDR S&P 500 ETF Trust • Robinhood Token",
    "address": "0x117cc2133c37B721F49dE2A7a74833232B3B4C0C",
    "decimals": 18,
    "liquidityUsd": 9609958,
    "volume24hUsd": 4075253,
    "bestPool": {
      "version": "v3",
      "id": "0xDDCBBa3666f578E3F09516f21Ff85BFee859AB5e",
      "quote": "WETH",
      "fee": 500,
      "liquidityUsd": 2935711
    },
    "pools": 17
  },
  {
    "symbol": "NVDA",
    "name": "NVIDIA • Robinhood Token",
    "address": "0xd0601CE157Db5bdC3162BbaC2a2C8aF5320D9EEC",
    "decimals": 18,
    "liquidityUsd": 5851949,
    "volume24hUsd": 3180681,
    "bestPool": {
      "version": "v3",
      "id": "0xd4EB21209C4D6093f80B5b84f5C45cc093EA14a3",
      "quote": "USDG",
      "fee": 500,
      "liquidityUsd": 3022527
    },
    "pools": 19
  },
  {
    "symbol": "SPCX",
    "name": "Space Exploration Technologies Corp. Class A Common Stock • Robinhood Token",
    "address": "0x4a0E65A3EcceC6dBe60AE065F2e7bb85Fae35eEa",
    "decimals": 18,
    "liquidityUsd": 5738494,
    "volume24hUsd": 3012023,
    "bestPool": {
      "version": "v3",
      "id": "0xc61284332117c3FB23A2A56cceFFD07F7aF60029",
      "quote": "USDG",
      "fee": 500,
      "liquidityUsd": 1577144
    },
    "pools": 20
  },
  {
    "symbol": "GLD",
    "name": "SPDR Gold Trust • Robinhood Token",
    "address": "0xC9a981FEE1F9DEc688bb123ccDeCc63D0deBFC4e",
    "decimals": 18,
    "liquidityUsd": 5068057,
    "volume24hUsd": 1900254,
    "bestPool": {
      "version": "v3",
      "id": "0x7A6A053eCCf1446A2633E05aA6D40D09381997ec",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 2216832
    },
    "pools": 15
  },
  {
    "symbol": "CRCL",
    "name": "Circle Internet Group • Robinhood Token",
    "address": "0xdF0992E440dD0be65BD8439b609d6D4366bf1CB5",
    "decimals": 18,
    "liquidityUsd": 4160399,
    "volume24hUsd": 1359085,
    "bestPool": {
      "version": "v3",
      "id": "0x654E4143e82a5824445Ade0824351C2A9ACD95a8",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 2943392
    },
    "pools": 17
  },
  {
    "symbol": "MSTR",
    "name": "Strategy Inc. • Robinhood Token",
    "address": "0xec262a75e413fAfD0dF80480274532C79D42da09",
    "decimals": 18,
    "liquidityUsd": 3949250,
    "volume24hUsd": 1183079,
    "bestPool": {
      "version": "v4",
      "id": "0x319bac87e616a89e241c10aeb8afd4892a852cdd8b373cd9765ecddc40b87cfe",
      "quote": "USDG",
      "fee": 2500,
      "liquidityUsd": 1656659
    },
    "pools": 14
  },
  {
    "symbol": "USO",
    "name": "United States Oil Fund • Robinhood Token",
    "address": "0xa30FA36Db767ad9eD3f7a60fC79526fB4d56D344",
    "decimals": 18,
    "liquidityUsd": 3676964,
    "volume24hUsd": 162074,
    "bestPool": {
      "version": "v3",
      "id": "0x02175608F1b5E6b5ed221cCFdC7Be197D111D915",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 3300236
    },
    "pools": 7
  },
  {
    "symbol": "META",
    "name": "Meta Platforms • Robinhood Token",
    "address": "0xc0D6457C16Cc70d6790Dd43521C899C87ce02f35",
    "decimals": 18,
    "liquidityUsd": 2675023,
    "volume24hUsd": 658808,
    "bestPool": {
      "version": "v4",
      "id": "0x5875d407a42965b0e768c8925cea290e06fa50603ef34fc99eb92a1050e6ae36",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 1964557
    },
    "pools": 17
  },
  {
    "symbol": "TSLA",
    "name": "Tesla • Robinhood Token",
    "address": "0x322F0929c4625eD5bAd873c95208D54E1c003b2d",
    "decimals": 18,
    "liquidityUsd": 2257231,
    "volume24hUsd": 400361,
    "bestPool": {
      "version": "v4",
      "id": "0x8517f8071ae5b831b738052f12125e8e3d6c158b78728aa44ce3b25e5104d32e",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 841352
    },
    "pools": 16
  },
  {
    "symbol": "MU",
    "name": "Micron Technology • Robinhood Token",
    "address": "0xfF080c8ce2E5feadaCa0Da81314Ae59D232d4afD",
    "decimals": 18,
    "liquidityUsd": 2088052,
    "volume24hUsd": 996742,
    "bestPool": {
      "version": "v3",
      "id": "0xd057B1Bc54917855BBee58eAd58647f47caB35E5",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 1611936
    },
    "pools": 10
  },
  {
    "symbol": "SGOV",
    "name": "iShares 0-3 Month Treasury Bond • Robinhood Token",
    "address": "0x92FD66527192E3e61d4DDd13322Aa222DE86F9B5",
    "decimals": 18,
    "liquidityUsd": 2070356,
    "volume24hUsd": 49726,
    "bestPool": {
      "version": "v3",
      "id": "0xfAb520051f96F4D2a32c22B6a3dD7fFfdf231bFe",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 1615090
    },
    "pools": 7
  },
  {
    "symbol": "GOOGL",
    "name": "Alphabet Class A • Robinhood Token",
    "address": "0x2e0847E8910a9732eB3fb1bb4b70a580ADAD4FE3",
    "decimals": 18,
    "liquidityUsd": 1703159,
    "volume24hUsd": 777163,
    "bestPool": {
      "version": "v3",
      "id": "0x34D0dC122CF9A8Eb296fC5e0D3A233625D7d19b7",
      "quote": "USDG",
      "fee": 500,
      "liquidityUsd": 603944
    },
    "pools": 17
  },
  {
    "symbol": "AAPL",
    "name": "Apple • Robinhood Token",
    "address": "0xaF3D76f1834A1d425780943C99Ea8A608f8a93f9",
    "decimals": 18,
    "liquidityUsd": 1540467,
    "volume24hUsd": 773513,
    "bestPool": {
      "version": "v4",
      "id": "0xc748f4671a867db48b552f6b7650bf3255e05f80f00e3f7aad1b17ccb7898fdb",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 485367
    },
    "pools": 16
  },
  {
    "symbol": "QQQ",
    "name": "Invesco QQQ • Robinhood Token",
    "address": "0xD5f3879160bc7c32ebb4dC785F8a4F505888de68",
    "decimals": 18,
    "liquidityUsd": 1436658,
    "volume24hUsd": 1216694,
    "bestPool": {
      "version": "v3",
      "id": "0xD60A5d14dB690B7Afad71F76B108071D7175597d",
      "quote": "USDG",
      "fee": 500,
      "liquidityUsd": 1008409
    },
    "pools": 11
  },
  {
    "symbol": "COIN",
    "name": "Coinbase • Robinhood Token",
    "address": "0x6330D8C3178a418788dF01a47479c0ce7CCF450b",
    "decimals": 18,
    "liquidityUsd": 1343927,
    "volume24hUsd": 245649,
    "bestPool": {
      "version": "v4",
      "id": "0x007a13fa152f6dc383cad20a8eaab4e1e2538b606936eae2a424f8aa47d6db31",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 719741
    },
    "pools": 10
  },
  {
    "symbol": "HIMS",
    "name": "Hims & Hers Health • Robinhood Token",
    "address": "0xCceE82fE024c36fA15E1005edE3E9e4787e23D09",
    "decimals": 18,
    "liquidityUsd": 1272683,
    "volume24hUsd": 683914,
    "bestPool": {
      "version": "v3",
      "id": "0xC8C90d3a1c1a24967E773ac2aD0d456BA3E31F64",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 527321
    },
    "pools": 10
  },
  {
    "symbol": "RDDT",
    "name": "Reddit • Robinhood Token",
    "address": "0x05b37Fb53A299a1b874A619e1c4C404D52C36F4C",
    "decimals": 18,
    "liquidityUsd": 1069410,
    "volume24hUsd": 69190,
    "bestPool": {
      "version": "v3",
      "id": "0xa8744E76aED23B05F0126335E7BD38f7935D19fe",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 759489
    },
    "pools": 7
  },
  {
    "symbol": "SKHY",
    "name": "SK hynix Inc. American Depositary Shares • Robinhood Token",
    "address": "0x84CAb63bc87912E71ad199ff14A0bA45de68FeF8",
    "decimals": 18,
    "liquidityUsd": 1041659,
    "volume24hUsd": 58666,
    "bestPool": {
      "version": "v4",
      "id": "0x742282d7cd423bacc97e7f07121bbd7958d03059f8accfada01a0c5efc903397",
      "quote": "USDG",
      "fee": 0,
      "liquidityUsd": 891860
    },
    "pools": 7
  },
  {
    "symbol": "BABA",
    "name": "Alibaba • Robinhood Token",
    "address": "0xad25Ac6C84D497db898fa1E8387bf6Af3532a1c4",
    "decimals": 18,
    "liquidityUsd": 1020457,
    "volume24hUsd": 39833,
    "bestPool": {
      "version": "v4",
      "id": "0xfe709115a71c7f9c007f2ac9cb932071ff3b3117865122134e2c1bd96719734c",
      "quote": "USDG",
      "fee": 0,
      "liquidityUsd": 877431
    },
    "pools": 6
  },
  {
    "symbol": "AMC",
    "name": "AMC Entertainment • Robinhood Token",
    "address": "0x05a3d1Cd21d0C88145E82600E62e7E496e0F222B",
    "decimals": 18,
    "liquidityUsd": 996013,
    "volume24hUsd": 817134,
    "bestPool": {
      "version": "v3",
      "id": "0xaA34feA710a1A737840329051D81D3B0B7C564d5",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 439900
    },
    "pools": 13
  },
  {
    "symbol": "COST",
    "name": "Costco • Robinhood Token",
    "address": "0x4EA005168D7F09a7A0Ba9D1DEf21a479950E44C2",
    "decimals": 18,
    "liquidityUsd": 840198,
    "volume24hUsd": 15070,
    "bestPool": {
      "version": "v3",
      "id": "0x0a2121A50A09eD0796ae81F9c53fF9398355a398",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 781742
    },
    "pools": 6
  },
  {
    "symbol": "PLTR",
    "name": "Palantir Technologies • Robinhood Token",
    "address": "0x894E1EC2D74FFE5AEF8Dc8A9e84686acCB964F2A",
    "decimals": 18,
    "liquidityUsd": 836405,
    "volume24hUsd": 548355,
    "bestPool": {
      "version": "v4",
      "id": "0xee430ee1003e1985e1828a01b9a20dad67ad4302994fe2abb4a173de4ac54623",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 647356
    },
    "pools": 8
  },
  {
    "symbol": "AMZN",
    "name": "Amazon • Robinhood Token",
    "address": "0x12f190a9F9d7D37a250758b26824B97CE941bF54",
    "decimals": 18,
    "liquidityUsd": 751453,
    "volume24hUsd": 204241,
    "bestPool": {
      "version": "v3",
      "id": "0x8AC92DA74AB5F3b1d024Dc1943Ad7e15Dc4179Ef",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 572079
    },
    "pools": 14
  },
  {
    "symbol": "INTC",
    "name": "Intel • Robinhood Token",
    "address": "0xc72b96e0E48ecd4DC75E1e45396e26300BC39681",
    "decimals": 18,
    "liquidityUsd": 687976,
    "volume24hUsd": 282131,
    "bestPool": {
      "version": "v3",
      "id": "0x2e5a92f5013a64661A49312111be2e8aBd33F56a",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 309387
    },
    "pools": 8
  },
  {
    "symbol": "MSFT",
    "name": "Microsoft • Robinhood Token",
    "address": "0xe93237C50D904957Cf27E7B1133b510C669c2e74",
    "decimals": 18,
    "liquidityUsd": 660241,
    "volume24hUsd": 188547,
    "bestPool": {
      "version": "v3",
      "id": "0xeb60bCD1D920ad6E102690CCFC6fB488899E1510",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 489023
    },
    "pools": 10
  },
  {
    "symbol": "AMD",
    "name": "AMD • Robinhood Token",
    "address": "0x86923f96303D656E4aa86D9d42D1e57ad2023fdC",
    "decimals": 18,
    "liquidityUsd": 626441,
    "volume24hUsd": 296242,
    "bestPool": {
      "version": "v4",
      "id": "0xde9f85fdd9e05a943a52f2c69ffafe3064a3287df03d02c9b431bc92d4781274",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 332549
    },
    "pools": 7
  },
  {
    "symbol": "RBLX",
    "name": "Roblox • Robinhood Token",
    "address": "0xF0C4BF4C582cb3836e98394b1d4e7B7281101bE8",
    "decimals": 18,
    "liquidityUsd": 544264,
    "volume24hUsd": 24740,
    "bestPool": {
      "version": "v3",
      "id": "0x6d25417718A8D6c529130a8ccC4BfBf0a18219D3",
      "quote": "WETH",
      "fee": 3000,
      "liquidityUsd": 297507
    },
    "pools": 7
  },
  {
    "symbol": "GME",
    "name": "GameStop • Robinhood Token",
    "address": "0x1b0E319c6A659F002271B69dB8A7df2F911c153E",
    "decimals": 18,
    "liquidityUsd": 522480,
    "volume24hUsd": 487618,
    "bestPool": {
      "version": "v3",
      "id": "0xE9713f453aDB9245B19559790c96F470a18F2fDF",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 320218
    },
    "pools": 13
  },
  {
    "symbol": "LLY",
    "name": "Eli Lilly • Robinhood Token",
    "address": "0x8005d266423c7ea827372c9c864491e5786600ea",
    "decimals": 18,
    "liquidityUsd": 511931,
    "volume24hUsd": 41755,
    "bestPool": {
      "version": "v3",
      "id": "0xf4274130137eee20bad928b593d992716516ceb9",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 229979
    },
    "pools": 6
  },
  {
    "symbol": "DELL",
    "name": "Dell • Robinhood Token",
    "address": "0x941AE714EC6D8130c7B75d67160Ca08f1e7d11Dd",
    "decimals": 18,
    "liquidityUsd": 443231,
    "volume24hUsd": 7839,
    "bestPool": {
      "version": "v3",
      "id": "0xc30c89cB7815A1488b7998D15eEC73961707Fc5a",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 396781
    },
    "pools": 4
  },
  {
    "symbol": "DJT",
    "name": "Trump Media & Technology Group • Robinhood Token",
    "address": "0x1D11f0496982706C5e14A514D4E79F2e6BdE4516",
    "decimals": 18,
    "liquidityUsd": 436497,
    "volume24hUsd": 34488,
    "bestPool": {
      "version": "v3",
      "id": "0x31a89afd92F9397465649AD03226c52292fc1ae5",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 156675
    },
    "pools": 12
  },
  {
    "symbol": "SNDK",
    "name": "Sandisk Corporation • Robinhood Token",
    "address": "0xB90A19fF0Af67f7779afF50A882A9CfF42446400",
    "decimals": 18,
    "liquidityUsd": 372407,
    "volume24hUsd": 30261,
    "bestPool": {
      "version": "v4",
      "id": "0x2707cb88a6a40fa0f948f58958051ba097d6f6a3cf7f87929bd68ccc5becea24",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 315709
    },
    "pools": 7
  },
  {
    "symbol": "SLV",
    "name": "iShares Silver Trust • Robinhood Token",
    "address": "0x411eFb0E7f985935DAec3D4C3ebaEa0d0AD7D89f",
    "decimals": 18,
    "liquidityUsd": 349464,
    "volume24hUsd": 47559,
    "bestPool": {
      "version": "v3",
      "id": "0x8cB787e6c315D464775289BaD00FDD67d53Ecb3D",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 322031
    },
    "pools": 6
  },
  {
    "symbol": "TTWO",
    "name": "Take-Two Interactive Software • Robinhood Token",
    "address": "0x5e81213613b6B86EaB4c6c50d718d34359459786",
    "decimals": 18,
    "liquidityUsd": 336696,
    "volume24hUsd": 80383,
    "bestPool": {
      "version": "v3",
      "id": "0xD9Ab4b7fAe6DC2f7020134Ec744A8F53Ef3E5E24",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 180638
    },
    "pools": 11
  },
  {
    "symbol": "MRNA",
    "name": "Moderna • Robinhood Token",
    "address": "0x43B07D15cE533bEc5476d70C22a78a1B2B662155",
    "decimals": 18,
    "liquidityUsd": 315184,
    "volume24hUsd": 203600,
    "bestPool": {
      "version": "v3",
      "id": "0xB40196272A6d2EB5edF6d93bc4DC39856AD95E0E",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 186304
    },
    "pools": 7
  },
  {
    "symbol": "TSM",
    "name": "Taiwan Semiconductor Manufacturing • Robinhood Token",
    "address": "0x58FfE4a942d3885bAa22D7520691F611EF09e7AA",
    "decimals": 18,
    "liquidityUsd": 304938,
    "volume24hUsd": 152322,
    "bestPool": {
      "version": "v4",
      "id": "0x0ba5d53d2f6255f334b7c8ead4f56b6aef5af3402c5e4d11180afd38c6b85fb1",
      "quote": "USDG",
      "fee": 7500,
      "liquidityUsd": 233142
    },
    "pools": 7
  },
  {
    "symbol": "NFLX",
    "name": "Netflix • Robinhood Token",
    "address": "0xE0444EF8BF4eD74f74FD73686e2ddF4C1c5591E8",
    "decimals": 18,
    "liquidityUsd": 274520,
    "volume24hUsd": 7664,
    "bestPool": {
      "version": "v3",
      "id": "0x59895C0302F41aEaa129D2fa2442CEc01E7eF45E",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 180012
    },
    "pools": 5
  },
  {
    "symbol": "AVGO",
    "name": "Broadcom • Robinhood Token",
    "address": "0x156E175DD063a8cE274C50654eF40e0032b3fbcF",
    "decimals": 18,
    "liquidityUsd": 198606,
    "volume24hUsd": 2594,
    "bestPool": {
      "version": "v3",
      "id": "0x5B7C404f1d7d77F9f3885aB13d7764F8a173028c",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 173386
    },
    "pools": 3
  },
  {
    "symbol": "BE",
    "name": "Bloom Energy • Robinhood Token",
    "address": "0x822CC93fFD030293E9842c30BBD678F530701867",
    "decimals": 18,
    "liquidityUsd": 180412,
    "volume24hUsd": 40833,
    "bestPool": {
      "version": "v3",
      "id": "0x1baD145C8F06444E0dF81c28257cd20231Bd1f16",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 151347
    },
    "pools": 6
  },
  {
    "symbol": "NBIS",
    "name": "Nebius Group • Robinhood Token",
    "address": "0x9D9c6684F596F66a64C030B93A886D51Fd4D7931",
    "decimals": 18,
    "liquidityUsd": 178770,
    "volume24hUsd": 4841,
    "bestPool": {
      "version": "v4",
      "id": "0x7c2f9ce1214ba9baf56d1b6a1fc640c1b63e9a711172c0c7d10e5a9c4a3d4f0c",
      "quote": "USDG",
      "fee": 9900,
      "liquidityUsd": 178770
    },
    "pools": 3
  },
  {
    "symbol": "FIG",
    "name": "Figma • Robinhood Token",
    "address": "0x41F4267525a8AFf329540eF24fD83d9044758B33",
    "decimals": 18,
    "liquidityUsd": 151890,
    "volume24hUsd": 3497,
    "bestPool": {
      "version": "v3",
      "id": "0xca5904C0a9d42F0Ec1Bf760FDf779907877144fD",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 149632
    },
    "pools": 3
  },
  {
    "symbol": "IBM",
    "name": "IBM • Robinhood Token",
    "address": "0x980dcf6766FA79f5Cf0c4AAdb3ab477ff15a9619",
    "decimals": 18,
    "liquidityUsd": 149897,
    "volume24hUsd": 3200,
    "bestPool": {
      "version": "v3",
      "id": "0x8cD848ce18b829C5c769AFf27164078bB52e0E97",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 102444
    },
    "pools": 8
  },
  {
    "symbol": "ORCL",
    "name": "Oracle • Robinhood Token",
    "address": "0xb0992820E760d836549ba69BC7598b4af75dEE03",
    "decimals": 18,
    "liquidityUsd": 132376,
    "volume24hUsd": 3085,
    "bestPool": {
      "version": "v4",
      "id": "0xc2ce4784e1e72cf0221b51b30c8aaadf6c0b12863cf03ab3687854fb7b1d850a",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 128663
    },
    "pools": 2
  },
  {
    "symbol": "SNAP",
    "name": "Snap • Robinhood Token",
    "address": "0xF6589F11Bc40b669e584073F428B05562F568733",
    "decimals": 18,
    "liquidityUsd": 113513,
    "volume24hUsd": 24735,
    "bestPool": {
      "version": "v3",
      "id": "0x0EbD4650C9e641E9745b5A508A2D46935DFE753E",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 71143
    },
    "pools": 9
  },
  {
    "symbol": "CRWV",
    "name": "CoreWeave • Robinhood Token",
    "address": "0x5f10A1C971B69e47e059e1dC91901B59b3fB49C3",
    "decimals": 18,
    "liquidityUsd": 107252,
    "volume24hUsd": 3268,
    "bestPool": {
      "version": "v4",
      "id": "0x237014478f7ef98afbe7412ac35b6a3f96b8fb111de48b7c4dbf49dba4bd9c4b",
      "quote": "USDG",
      "fee": 9000,
      "liquidityUsd": 107252
    },
    "pools": 3
  },
  {
    "symbol": "NET",
    "name": "Cloudflare, Inc. Class A common stock • Robinhood Token",
    "address": "0x116F00968269B7bfbaD4109cE591d6E74c0601d4",
    "decimals": 18,
    "liquidityUsd": 99535,
    "volume24hUsd": 17754,
    "bestPool": {
      "version": "v3",
      "id": "0xA9Caebb1b2fB2b954F192572b309aEf1cAf6a330",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 43695
    },
    "pools": 6
  },
  {
    "symbol": "PFE",
    "name": "Pfizer • Robinhood Token",
    "address": "0x7066A64c24e4206CD62E83bf198c1E7EB361F51e",
    "decimals": 18,
    "liquidityUsd": 86259,
    "volume24hUsd": 14751,
    "bestPool": {
      "version": "v3",
      "id": "0xC7d573Fcda6D2107C97fb582ae18411F9Db32E7f",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 64115
    },
    "pools": 4
  },
  {
    "symbol": "QUBT",
    "name": "Quantum Computing • Robinhood Token",
    "address": "0x59818904ab4cE163b3cE4FfB64f2D6Ca02c434B4",
    "decimals": 18,
    "liquidityUsd": 78005,
    "volume24hUsd": 1049,
    "bestPool": {
      "version": "v3",
      "id": "0x227Bbce9A81B3694b01754298a983Be3F9E44A93",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 68235
    },
    "pools": 4
  },
  {
    "symbol": "LULU",
    "name": "Lululemon • Robinhood Token",
    "address": "0x4e62068525Ab11FE768e29dfD00ef909B9803016",
    "decimals": 18,
    "liquidityUsd": 76876,
    "volume24hUsd": 13132,
    "bestPool": {
      "version": "v3",
      "id": "0x0F4227D27082B3BCA6818381b9ea6460275e49f4",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 41030
    },
    "pools": 10
  },
  {
    "symbol": "GLXY",
    "name": "Galaxy Digital Inc. • Robinhood Token",
    "address": "0x2D427692E928fa156ec22acfaBaFA0447C5805B7",
    "decimals": 18,
    "liquidityUsd": 76054,
    "volume24hUsd": 20117,
    "bestPool": {
      "version": "v3",
      "id": "0xC67C2D200E0b7E5D99F4CFBede8CB09B48892f2c",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 41686
    },
    "pools": 6
  },
  {
    "symbol": "BA",
    "name": "Boeing • Robinhood Token",
    "address": "0x4D21483a44Bf67a86b77E3dA301411880797D452",
    "decimals": 18,
    "liquidityUsd": 75891,
    "volume24hUsd": 312,
    "bestPool": {
      "version": "v3",
      "id": "0xc6517047b189c72D3bAa9eF37D1d28F27a63638a",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 58718
    },
    "pools": 4
  },
  {
    "symbol": "BB",
    "name": "Blackberry • Robinhood Token",
    "address": "0x48E39E56aCdbA37b09020C0b734A613C9a2f100A",
    "decimals": 18,
    "liquidityUsd": 70718,
    "volume24hUsd": 1426,
    "bestPool": {
      "version": "v4",
      "id": "0xc250650901b49785b18443a0b1bfee10b98f5c20f11988635252030e5283a288",
      "quote": "USDG",
      "fee": 7100,
      "liquidityUsd": 27868
    },
    "pools": 6
  },
  {
    "symbol": "UPS",
    "name": "UPS • Robinhood Token",
    "address": "0xf23250dac154D05Bb671CB0d0eBEf3c635c79CE2",
    "decimals": 18,
    "liquidityUsd": 67700,
    "volume24hUsd": 9873,
    "bestPool": {
      "version": "v3",
      "id": "0x3Ab74C45DceCC6A62898204Dd42143a816B44CB1",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 42033
    },
    "pools": 5
  },
  {
    "symbol": "RIVN",
    "name": "Rivian Automotive • Robinhood Token",
    "address": "0xB1BF26c1D20ff267A4f93550d1E0d06ac40a114B",
    "decimals": 18,
    "liquidityUsd": 65743,
    "volume24hUsd": 2305,
    "bestPool": {
      "version": "v3",
      "id": "0xb30A75B200D98A600a3766869344928E35823E23",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 41510
    },
    "pools": 3
  },
  {
    "symbol": "BULL",
    "name": "Webull • Robinhood Token",
    "address": "0xceF9027c7d6985b85f0BA431125073529A947A68",
    "decimals": 18,
    "liquidityUsd": 64810,
    "volume24hUsd": 78,
    "bestPool": {
      "version": "v4",
      "id": "0xdfc620485cebd394955e7cde9e3d336ec8dabe24a7c80c4b9de71ea896208e79",
      "quote": "USDG",
      "fee": 8000,
      "liquidityUsd": 58899
    },
    "pools": 4
  },
  {
    "symbol": "F",
    "name": "Ford Motor • Robinhood Token",
    "address": "0x25C288E6D899b9BC30160965aD9644c67e73bE0C",
    "decimals": 18,
    "liquidityUsd": 64705,
    "volume24hUsd": 140,
    "bestPool": {
      "version": "v3",
      "id": "0x4dbAC19E895322ac5b93abad9008691632bFFC05",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 64705
    },
    "pools": 2
  },
  {
    "symbol": "LMT",
    "name": "Lockheed • Robinhood Token",
    "address": "0x329fcACEb9AD6F9580DD5F643fed0646900D043c",
    "decimals": 18,
    "liquidityUsd": 55449,
    "volume24hUsd": 714,
    "bestPool": {
      "version": "v4",
      "id": "0x0b118d2480ebdb11374d3ad2ea1b935e9458a9f704222004b3b8de07bc98f1eb",
      "quote": "USDG",
      "fee": 5000,
      "liquidityUsd": 37478
    },
    "pools": 6
  },
  {
    "symbol": "NU",
    "name": "Nu • Robinhood Token",
    "address": "0x408c14038a04f7bD235329E26d2bf569ee20e250",
    "decimals": 18,
    "liquidityUsd": 54733,
    "volume24hUsd": 105,
    "bestPool": {
      "version": "v3",
      "id": "0xb6d047637151f6De1d02028acdd187Aa9cb7AFE3",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 46636
    },
    "pools": 3
  },
  {
    "symbol": "QCOM",
    "name": "Qualcomm • Robinhood Token",
    "address": "0x0f17206447090e464C277571124dD2688E48AEA9",
    "decimals": 18,
    "liquidityUsd": 54584,
    "volume24hUsd": 2388,
    "bestPool": {
      "version": "v4",
      "id": "0x106af997d180cf37a574c42c04179f267b9245cf221b1c57fb3e491137915de6",
      "quote": "USDG",
      "fee": 3500,
      "liquidityUsd": 54254
    },
    "pools": 4
  },
  {
    "symbol": "USAR",
    "name": "USA Rare Earth • Robinhood Token",
    "address": "0xd917B029C761D264c6A312BBbcDA868658eF86a6",
    "decimals": 18,
    "liquidityUsd": 51943,
    "volume24hUsd": 1452,
    "bestPool": {
      "version": "v3",
      "id": "0x04391780F519B7d3ba59c9590459D76e23d225C4",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 51943
    },
    "pools": 3
  },
  {
    "symbol": "JNJ",
    "name": "Johnson & Johnson • Robinhood Token",
    "address": "0x03DfbBE0AC4E7bCDaFd08eD41A400326B77D8c80",
    "decimals": 18,
    "liquidityUsd": 43814,
    "volume24hUsd": 2400,
    "bestPool": {
      "version": "v3",
      "id": "0x7F0aCE18D1dCEd47063CF26e649bc8AB14D09e67",
      "quote": "USDG",
      "fee": 3000,
      "liquidityUsd": 27319
    },
    "pools": 8
  },
  {
    "symbol": "INDA",
    "name": "iShares MSCI India ETF • Robinhood Token",
    "address": "0xACEF2e09adb47aD6aBeBAD9fF06689E60615C2B6",
    "decimals": 18,
    "liquidityUsd": 43272,
    "volume24hUsd": 11216,
    "bestPool": {
      "version": "v4",
      "id": "0x7d0895d8162b0be326ef944faeb5a84f4a08377b9bc9f010e38fa4d268a94469",
      "quote": "USDG",
      "fee": 2000,
      "liquidityUsd": 41680
    },
    "pools": 5
  },
  {
    "symbol": "SOXX",
    "name": "iShares Semiconductor ETF • Robinhood Token",
    "address": "0x75742c18BC1f1C5c5f448f4C9D9C6F66dafAAa38",
    "decimals": 18,
    "liquidityUsd": 39922,
    "volume24hUsd": 5211,
    "bestPool": {
      "version": "v4",
      "id": "0xda48bde4c58cb3364d522c1f3141376f8e20036d207bbb93191cb1fe65eaa95a",
      "quote": "USDG",
      "fee": 9000,
      "liquidityUsd": 19436
    },
    "pools": 4
  },
  {
    "symbol": "MRVL",
    "name": "Marvell Technology • Robinhood Token",
    "address": "0x62fd0668e10D8B72339BE2DCF7643001688ff13B",
    "decimals": 18,
    "liquidityUsd": 39461,
    "volume24hUsd": 5194,
    "bestPool": {
      "version": "v3",
      "id": "0x5201ea77c950aBB8d3706A20bF3b83d872E4A98b",
      "quote": "WETH",
      "fee": 3000,
      "liquidityUsd": 19789
    },
    "pools": 4
  },
  {
    "symbol": "RCAT",
    "name": "Red Cat • Robinhood Token",
    "address": "0xFDE6b5d9BB419B10C23268c74e369AbFF39C0460",
    "decimals": 18,
    "liquidityUsd": 35570,
    "volume24hUsd": 314,
    "bestPool": {
      "version": "v3",
      "id": "0x64710a70839585Af718e1B1FAEf9E7f1665F1116",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 24211
    },
    "pools": 2
  },
  {
    "symbol": "DDOG",
    "name": "Datadog • Robinhood Token",
    "address": "0x27c99fBde9D0d2AA4f4Bfb4943f237843DdF6958",
    "decimals": 18,
    "liquidityUsd": 31208,
    "volume24hUsd": 301,
    "bestPool": {
      "version": "v4",
      "id": "0x977c78c96cd9b306d87c235dee5a69ccab913b0f775575627e709643ad416598",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 22392
    },
    "pools": 7
  },
  {
    "symbol": "WYFI",
    "name": "WhiteFiber, Inc. • Robinhood Token",
    "address": "0x9e7ABD3C9139D14E4c86DcE0e455AAB7A0C2FB3E",
    "decimals": 18,
    "liquidityUsd": 30060,
    "volume24hUsd": 78,
    "bestPool": {
      "version": "v4",
      "id": "0xade8f03250521f174360017d003aac3b30df3633ca31769e23a7906bb3c6262d",
      "quote": "USDG",
      "fee": 11100,
      "liquidityUsd": 30052
    },
    "pools": 4
  },
  {
    "symbol": "VTI",
    "name": "Vanguard Morningstar Total Stock Market ETF • Robinhood Token",
    "address": "0x0594134DF3f171a354D9C85eBD65b7A6148F6D09",
    "decimals": 18,
    "liquidityUsd": 28807,
    "volume24hUsd": null,
    "bestPool": {
      "version": "v3",
      "id": "0xb78dd1a97fa544c65d7d1f12453ecaaf1e05c36d",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 28807
    },
    "pools": 1
  },
  {
    "symbol": "WDC",
    "name": "Western Digital • Robinhood Token",
    "address": "0xF52597345A8Edf418bc4071b4a35112472277D3e",
    "decimals": 18,
    "liquidityUsd": 27010,
    "volume24hUsd": 460,
    "bestPool": {
      "version": "v4",
      "id": "0xa4a0d1f0683b902c3b3438d0bce3676d9cb9264c7f859b0893e3388a645fb149",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 27010
    },
    "pools": 2
  },
  {
    "symbol": "ASML",
    "name": "ASML Holding NV • Robinhood Token",
    "address": "0x47F93d52cBeC7C6D2CfC080e154002370a60dAEA",
    "decimals": 18,
    "liquidityUsd": 25794,
    "volume24hUsd": 1510,
    "bestPool": {
      "version": "v3",
      "id": "0xedb22516B14Eb2d1C86927Db373B0E8bF70F5cD1",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 24572
    },
    "pools": 2
  },
  {
    "symbol": "HPE",
    "name": "HP Enterprise • Robinhood Token",
    "address": "0x59dd09d4900C2E4B5F75b7c0d4E6796fcc234Cb1",
    "decimals": 18,
    "liquidityUsd": 20553,
    "volume24hUsd": 420,
    "bestPool": {
      "version": "v4",
      "id": "0x8449bc525b02fb251bc7e281da91bdec6ef184a0e99f4a40bfa9a5fc7ebb4fcf",
      "quote": "USDG",
      "fee": 30000,
      "liquidityUsd": 12827
    },
    "pools": 4
  },
  {
    "symbol": "RKLB",
    "name": "Rocket Lab Corporation • Robinhood Token",
    "address": "0x3b14C39E89D60D627b42a1A4CA45b5bb45Fc12e2",
    "decimals": 18,
    "liquidityUsd": 18719,
    "volume24hUsd": 109,
    "bestPool": {
      "version": "v4",
      "id": "0xbbc15d66fef8391f53569e19016e86545be9de3f302b82db93ed6165236d22f3",
      "quote": "USDG",
      "fee": 9000,
      "liquidityUsd": 16539
    },
    "pools": 3
  },
  {
    "symbol": "SHOP",
    "name": "Shopify • Robinhood Token",
    "address": "0xF53F66751B1Eff985311b693531E3290F600c410",
    "decimals": 18,
    "liquidityUsd": 12730,
    "volume24hUsd": 1002,
    "bestPool": {
      "version": "v4",
      "id": "0x8baff387b51c50e2747e85bcddf87da78fee6efb45629743e1af4dfb07ad13ee",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 6269
    },
    "pools": 3
  },
  {
    "symbol": "EWY",
    "name": "iShares MSCI South Korea fund • Robinhood Token",
    "address": "0x7f0aBeF0C07280F82c6a08ead09dEd6BAE2C13Fc",
    "decimals": 18,
    "liquidityUsd": 11534,
    "volume24hUsd": 797,
    "bestPool": {
      "version": "v4",
      "id": "0xaac10c49a6386a702427c6cd4f378706ade03c53267080712f9e5d2fc496b61a",
      "quote": "USDG",
      "fee": 50000,
      "liquidityUsd": 8805
    },
    "pools": 5
  },
  {
    "symbol": "SOUN",
    "name": "SoundHound AI • Robinhood Token",
    "address": "0x6E3Dfd9f7e1649BaA14D25cac18C94d62dB10A54",
    "decimals": 18,
    "liquidityUsd": 11301,
    "volume24hUsd": 2,
    "bestPool": {
      "version": "v4",
      "id": "0x3a711e8c7cd240323cbd74912f72db9466839b98f645d9c20c5fcaa51ff5a7ae",
      "quote": "USDG",
      "fee": 35800,
      "liquidityUsd": 11301
    },
    "pools": 4
  },
  {
    "symbol": "CRM",
    "name": "Salesforce • Robinhood Token",
    "address": "0xd95B44124e475743a7589e68F3D74008A5536D44",
    "decimals": 18,
    "liquidityUsd": 10636,
    "volume24hUsd": 146,
    "bestPool": {
      "version": "v4",
      "id": "0x5d0434f1dcf45ff9450c1a63b5c9e088f90cfebf483458164e81be6fb96e2b2a",
      "quote": "USDG",
      "fee": 10000,
      "liquidityUsd": 10636
    },
    "pools": 2
  },
  {
    "symbol": "RUN",
    "name": "Sunrun • Robinhood Token",
    "address": "0x756Bc80af765C82da966a788858d65aDF14f3793",
    "decimals": 18,
    "liquidityUsd": 10353,
    "volume24hUsd": 32,
    "bestPool": {
      "version": "v4",
      "id": "0x87be5bc8f3196643f962d5d28fc9121f7c6c7b79f56d54827c76ef8c06d94020",
      "quote": "USDG",
      "fee": 6000,
      "liquidityUsd": 9828
    },
    "pools": 4
  }
];

export type RhCryptoToken = Omit<RhStockToken, "volume24hUsd"> & {
  kind: "crypto" | "stable";
  source: string;
  coingeckoId: string | null;
  marketCapUsd: number | null;
  /** File in apps/web/src/rh/brands/coins. */
  logo: string | null;
};

/**
 * Crypto on Robinhood Chain that passes the same rule (plus USDG, the only stablecoin supported).
 * Candidates: CoinGecko Robinhood mappings and canonical-bridge copies of top Ethereum tokens with a
 * market cap of at least $100,000,000, live on another chain too. ETH is held as WETH.
 */
export const RH_CRYPTO: RhCryptoToken[] = [
  {
    "symbol": "USDG",
    "name": "Global Dollar",
    "kind": "stable",
    "source": "Robinhood USDG",
    "coingeckoId": "global-dollar",
    "marketCapUsd": 3146096394,
    "address": "0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168",
    "decimals": 6,
    "liquidityUsd": 30190547,
    "bestPool": {
      "version": "v3",
      "id": "0x52e65b17fb6e5ba00ed806f37afcd2daa50271ca",
      "quote": "WETH",
      "fee": 100,
      "liquidityUsd": 19357993
    },
    "pools": 5,
    "logo": "usdg.png"
  },
  {
    "symbol": "ETH",
    "name": "WETH",
    "kind": "crypto",
    "source": "Robinhood WETH",
    "coingeckoId": "ethereum",
    "marketCapUsd": 286375852383,
    "address": "0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73",
    "decimals": 18,
    "liquidityUsd": 21270462,
    "bestPool": {
      "version": "v3",
      "id": "0x52e65B17fB6E5BA00Ed806f37Afcd2DaA50271Ca",
      "quote": "USDG",
      "fee": 100,
      "liquidityUsd": 13193962
    },
    "pools": 10,
    "logo": "eth.png"
  },
  {
    "symbol": "PONS",
    "name": "Pons",
    "kind": "crypto",
    "source": "CoinGecko (included: largest Robinhood Chain native coin)",
    "coingeckoId": "pons",
    "marketCapUsd": 154686775,
    "address": "0x39dBED3a2bd333467115dE45665cC57F813C4571",
    "decimals": 18,
    "liquidityUsd": 6222908,
    "bestPool": {
      "version": "v3",
      "id": "0x10CC6BD38112cAc182db90B6a71d8Bb5939526bA",
      "quote": "WETH",
      "fee": 10000,
      "liquidityUsd": 2413643
    },
    "pools": 17,
    "logo": "pons.png"
  },
  {
    "symbol": "cbBTC",
    "name": "Coinbase Wrapped BTC",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "coinbase-wrapped-btc",
    "marketCapUsd": 7727347014,
    "address": "0xCEC185eB182c47d1bA1EFc84e6959e18cd620Be4",
    "decimals": 8,
    "liquidityUsd": 4816822,
    "bestPool": {
      "version": "v3",
      "id": "0x934e60D1C6C34242b92159A5Bcc710FAFa50AD87",
      "quote": "WETH",
      "fee": 500,
      "liquidityUsd": 1923823
    },
    "pools": 15,
    "logo": "cbbtc.webp"
  },
  {
    "symbol": "VIRTUAL",
    "name": "Virtuals Protocol",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "virtual-protocol",
    "marketCapUsd": 411543250,
    "address": "0xc6911796042b15d7Fa4F6CDe69e245DdCd3d9c31",
    "decimals": 18,
    "liquidityUsd": 2752054,
    "bestPool": {
      "version": "v2",
      "id": "0xd95e8e2Cd04c207625C6F23c974d365a5F3A91D3",
      "quote": "WETH",
      "fee": 3000,
      "liquidityUsd": 1561396
    },
    "pools": 14,
    "logo": "virtual.png"
  },
  {
    "symbol": "UNI",
    "name": "Uniswap",
    "kind": "crypto",
    "source": "canonical bridge",
    "coingeckoId": "uniswap",
    "marketCapUsd": 4255632903,
    "address": "0xF177d86a28b520e3E396E4F3B96cd8e72D7dabd8",
    "decimals": 18,
    "liquidityUsd": 1186834,
    "bestPool": {
      "version": "v4",
      "id": "0xd0ce400b5a20071718f4220cd5e49700337fe8ccaeefe6cfcea65bba99b85e54",
      "quote": "ETH",
      "fee": 10000,
      "liquidityUsd": 1107711
    },
    "pools": 5,
    "logo": "uni.png"
  },
  {
    "symbol": "TAO",
    "name": "Bittensor",
    "kind": "crypto",
    "source": "CoinGecko (included: wrapped Bittensor)",
    "coingeckoId": "forevermoney-wrapped-tao",
    "marketCapUsd": 2822683471,
    "address": "0xf3081494B87e8D5fb7960f066E931D1D0e6E3d67",
    "decimals": 18,
    "liquidityUsd": 932705,
    "bestPool": {
      "version": "v3",
      "id": "0x572D51A3De7c220FDD19451e4e24183B9f2eCADc",
      "quote": "WETH",
      "fee": 10000,
      "liquidityUsd": 488489
    },
    "pools": 3,
    "logo": "tao.jpeg"
  },
  {
    "symbol": "LIT",
    "name": "Lighter",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "lighter",
    "marketCapUsd": 807488954,
    "address": "0xeeca2E7Dc194a320d349122d88259bB9595a4cB0",
    "decimals": 18,
    "liquidityUsd": 508650,
    "bestPool": {
      "version": "v4",
      "id": "0xecc90c8bd08ff7138856f4205e30ae38adfd529578ee925f010b0134f2c91f6a",
      "quote": "USDG",
      "fee": 9000,
      "liquidityUsd": 496502
    },
    "pools": 3,
    "logo": "lit.png"
  },
  {
    "symbol": "PENGU",
    "name": "Pudgy Penguins",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "pudgy-penguins",
    "marketCapUsd": 475400981,
    "address": "0x74BE72AFFAFbC8de30F0C11247814036314D625f",
    "decimals": 18,
    "liquidityUsd": 169919,
    "bestPool": {
      "version": "v4",
      "id": "0x38cbd4b134c801b6d534600ccf5c59ff06e5e5058f108ddef85aa66c15ffb086",
      "quote": "ETH",
      "fee": 10000,
      "liquidityUsd": 165640
    },
    "pools": 2,
    "logo": "pengu.png"
  },
  {
    "symbol": "PENDLE",
    "name": "Pendle",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "pendle",
    "marketCapUsd": 348308666,
    "address": "0x5E49E1f85813F2B65858860A3FA231b4186f2e0E",
    "decimals": 18,
    "liquidityUsd": 97859,
    "bestPool": {
      "version": "v4",
      "id": "0x2d4670ee0fcdccdff4705a163a4e3d0b426c782317db61f3ea06c5a98d5eb423",
      "quote": "ETH",
      "fee": 2500,
      "liquidityUsd": 97413
    },
    "pools": 3,
    "logo": "pendle.png"
  },
  {
    "symbol": "NPC",
    "name": "Non-Playable Coin",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "non-playable-coin",
    "marketCapUsd": 140376685,
    "address": "0x241F3Caad03Db31137F641beF005A32176530024",
    "decimals": 18,
    "liquidityUsd": 94027,
    "bestPool": {
      "version": "v2",
      "id": "0x5eA30aafd5fbA54bF1d962d349a96893D3Cd6DB5",
      "quote": "WETH",
      "fee": 3000,
      "liquidityUsd": 94027
    },
    "pools": 1,
    "logo": "npc.png"
  },
  {
    "symbol": "APE",
    "name": "ApeCoin",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "apecoin",
    "marketCapUsd": 129097145,
    "address": "0x8f86a15EC17cb3369d8b3E666dAdBC11daA82b79",
    "decimals": 18,
    "liquidityUsd": 33432,
    "bestPool": {
      "version": "v4",
      "id": "0x4263743142da2c86b408e001af4de92738253bc70f2f4acdb3c9a313f22e59a8",
      "quote": "ETH",
      "fee": 3000,
      "liquidityUsd": 31095
    },
    "pools": 3,
    "logo": "ape.png"
  },
  {
    "symbol": "1INCH",
    "name": "1INCH Token",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "1inch",
    "marketCapUsd": 125452405,
    "address": "0x1755C2910c126eE1b0CF1E08a307Dc9E787285a0",
    "decimals": 18,
    "liquidityUsd": 29056,
    "bestPool": {
      "version": "v4",
      "id": "0x1c365df278671237f4fbd5338f72683c1fd32685e3696938dd589afd5e0ab61b",
      "quote": "USDG",
      "fee": 28500,
      "liquidityUsd": 29056
    },
    "pools": 2,
    "logo": "1inch.jpg"
  },
  {
    "symbol": "LINK",
    "name": "ChainLink Token",
    "kind": "crypto",
    "source": "CoinGecko",
    "coingeckoId": "chainlink",
    "marketCapUsd": 8859511757,
    "address": "0x492641F648a4986844848E0beFE66D14817bCE34",
    "decimals": 18,
    "liquidityUsd": 28792,
    "bestPool": {
      "version": "v4",
      "id": "0x4ef7a4ea0123400860f9136ebcaa60ee1e1ac23c5a0cbba35aa664f719c27415",
      "quote": "USDG",
      "fee": 0,
      "liquidityUsd": 23437
    },
    "pools": 2,
    "logo": "link.png"
  }
];

/** Checked and excluded (on-chain but no Uniswap pool with enough liquidity). */
export const RH_CRYPTO_EXCLUDED: { symbol: string; address: string; why: string }[] = [
  {
    "symbol": "LINK",
    "address": "0x0822560CBDB92a0Af70397379ddb4Dcc4C95C8a7",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "SHIB",
    "address": "0xC313e8311Db3b39d416a75D1Cb61457C94669890",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "PEPE",
    "address": "0xeeba1996DAD6D981Bd90e812196b40d555EAA9eB",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "PAXG",
    "address": "0xc700C81925D1d1C10F996fA7c0Dee83a54C4Bb8D",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "MORPHO",
    "address": "0x2438699406E05d1743cd70469a1Ab91dA2C6Afb2",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "CRV",
    "address": "0xB29De138DaCA2476023ad45D01fD586e3D7b004c",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "VIRTUAL",
    "address": "0x8124dc4802d5D68FC848f6997cA4E7bE125a78E9",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "STRK",
    "address": "0x8499E0e58d0beaB003DD65eF61138eDaf9b6a8AC",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "PENDLE",
    "address": "0xa696193fDf5B694a9913acc3b331810DBc897743",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "SPX",
    "address": "0x1d0e48DE6327fCdD0F4b2d8EbEF2F7eD7563D629",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "OHM",
    "address": "0xB1C1B235bDd8b409f184187AE870f74a0F12D41E",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "SHFL",
    "address": "0x4FC8791D6F964bAd23DFa366970f557789F7C6f7",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "JPYC",
    "address": "0x9cc3164fB67FC9cBeD4b620953447F27B70EF71b",
    "why": "no Uniswap pool with on-chain liquidity"
  },
  {
    "symbol": "RLB",
    "address": "0xdAFe54Fd1591481CcdE981afb7094536a48EBE8C",
    "why": "no Uniswap pool with on-chain liquidity"
  }
];
